import script from "./Metrics.vue?vue&type=script&lang=ts&setup=true"
export * from "./Metrics.vue?vue&type=script&lang=ts&setup=true"

import "./Metrics.vue?vue&type=style&index=0&id=637dd22b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-637dd22b"]])

export default __exports__